var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoResult(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "039-search 1",
    clipPath: "url(#clip0_110_10715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M49.5936 99.6441L40.3561 90.4063L48.3705 82.3916L57.6083 91.6297L49.5936 99.6441Z",
    fill: "url(#paint0_linear_110_10715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M87.7012 101.389C114.813 101.389 136.792 79.4105 136.792 52.2985C136.792 25.1866 114.813 3.20801 87.7012 3.20801C60.5893 3.20801 38.6107 25.1866 38.6107 52.2985C38.6107 79.4105 60.5893 101.389 87.7012 101.389Z",
    fill: "url(#paint1_radial_110_10715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M87.7012 0C58.8175 0 35.4025 23.415 35.4025 52.2988C35.4025 81.1825 58.8175 104.598 87.7012 104.598C116.585 104.598 140 81.1828 140 52.2988C140 23.4147 116.585 0 87.7012 0ZM87.7012 95.9211C63.6092 95.9211 44.0789 76.3908 44.0789 52.2988C44.0789 28.2067 63.6092 8.67645 87.7012 8.67645C111.793 8.67645 131.324 28.207 131.324 52.2988C131.324 76.3905 111.793 95.9211 87.7012 95.9211Z",
    fill: "url(#paint2_linear_110_10715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.14055 138.454L1.54629 132.859C-0.51543 130.798 -0.51543 127.455 1.54629 125.393L36.4027 90.5361L49.4635 103.597L14.6073 138.454C12.5453 140.515 9.20227 140.515 7.14055 138.454Z",
    fill: "url(#paint3_linear_110_10715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M41.2697 86.7239L53.2766 98.7308C55.18 100.634 55.18 103.72 53.2766 105.624L52.6734 106.227C50.77 108.13 47.684 108.13 45.7803 106.227L33.7734 94.2201C31.87 92.3167 31.87 89.2307 33.7734 87.3271L34.3766 86.7239C36.28 84.8199 39.366 84.8199 41.2697 86.7239Z",
    fill: "url(#paint4_linear_110_10715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M43.4913 88.945L51.0549 96.5086C52.6553 98.109 52.6553 100.703 51.0549 102.304L49.3535 104.005C47.7531 105.606 45.1587 105.606 43.5583 104.005L35.9948 96.4416C34.3943 94.8412 34.3943 92.2468 35.9948 90.6464L37.6961 88.945C39.2965 87.3451 41.8912 87.3451 43.4913 88.945Z",
    fill: "url(#paint5_linear_110_10715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M46.272 91.7257L48.2741 93.7278C49.3315 94.7852 49.3315 96.4991 48.2741 97.5562L44.6065 101.224C43.5491 102.281 41.8352 102.281 40.7781 101.224L38.7759 99.2217C37.7186 98.1643 37.7186 96.4504 38.7759 95.3933L42.4436 91.7257C43.5009 90.6683 45.2149 90.6683 46.272 91.7257Z",
    fill: "url(#paint6_linear_110_10715)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 812147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M75 41.3157V41",
    stroke: "#C21C05",
    strokeWidth: 6.31408,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M100.256 41.3157V41",
    stroke: "#C21C05",
    strokeWidth: 6.31408,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M100.256 63.2553C98.6778 58.5197 94.6024 53.7842 87.6282 53.7842C80.6538 53.7842 76.5785 58.5197 75 63.2553",
    stroke: "#565656",
    strokeWidth: 6.31408,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_110_10715",
    x1: 55.4502,
    y1: 97.4825,
    x2: 46.6649,
    y2: 88.6972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97AAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_110_10715",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.6235 55.9151) scale(48.0186)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#FDFDFD",
    stopOpacity: 0.482
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#F6F7F7",
    stopOpacity: 0.655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#EBEDEC",
    stopOpacity: 0.779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#DADDDD",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "#C4CAC9",
    stopOpacity: 0.964
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8BFBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_110_10715",
    x1: 87.7039,
    y1: 9.59051,
    x2: 87.7039,
    y2: 128.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_110_10715",
    x1: 20.3139,
    y1: 113.035,
    x2: 30.8376,
    y2: 123.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_110_10715",
    x1: 39.2917,
    y1: 100.708,
    x2: 48.322,
    y2: 91.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97AAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_110_10715",
    x1: 51.439,
    y1: 88.5617,
    x2: 32.6609,
    y2: 107.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97AAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_110_10715",
    x1: 39.2916,
    y1: 100.708,
    x2: 48.3219,
    y2: 91.6774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97AAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_110_10715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoResult);
export default __webpack_public_path__ + "static/media/icon_no_result.d145486308e91d7fa669131d3cce28b3.svg";
export { ForwardRef as ReactComponent };